import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Provider as TransProvider } from 'react-translated';

class TransProviderWrapper extends React.Component {

  getChildContext() {
    return {
      translations: this.props.translations,
      language: this.props.lang,
      getTranslation: this.getTranslation
    };
  }

  getTranslation = (text: string, data: {}) => {
    const { lang, translations, debug } = this.props;
    let template = translations[text] ? translations[text][lang] : undefined;

    if(!template) {
      if(debug === true) console.error(`lack of translation "${text}"`);
      template = text;
    }

    if(typeof template === 'string') {
      if(data) {
        Object.keys(data).forEach(key => {
          template = template.replace(new RegExp(`{${key}}`, 'g'), data[key]);
        });
      }
      return template;
    }
    return template( { text, ...data });
  }

  render() {
    const { children, lang, translations } = this.props;
    return (
      <TransProvider language={lang} translation={translations}>
        <div>
          {children}
        </div>
      </TransProvider>
    );
  }
}

const mapState = state => ({
  lang: state.ui.language,
  translations: state.ui.translations
});

TransProviderWrapper.propTypes = {
  lang: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
  debug: PropTypes.bool,
};

TransProviderWrapper.childContextTypes = {
  translations: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  getTranslation: PropTypes.func.isRequired,
};

export default connect(mapState)(TransProviderWrapper);


// WEBPACK FOOTER //
// ./src/partialComponents/TransProvider.jsx